import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const button = css`
  inset-block-end: ${spacing(-0.5)};
  position: sticky;
`
export const submitButton = css`
  padding: ${spacing(1)}; // 8px
  transition: filter 0.2s ease-in-out;
`
